import * as React from "react";
import { UitkExpandoCard, UitkExpandoCardTypeSize } from "uitk-react-expando";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { DecorateEditorialHtml } from "../../../../ContentUtilities";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

export const CitifaqSection = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  const [isVisible, setIsVisible] = React.useState(false);
  const toggle = React.useCallback(() => setIsVisible(!isVisible), [isVisible]);

  if (items.length !== 2) {
    return null;
  }

  return (
    <UitkLayoutFlex space="two" wrap="wrap" justifyContent="center">
      <UitkLayoutFlexItem grow={1} minWidth="twenty_four" maxWidth="one_hundred_twenty">
        <div className="all-b-padding-three">
          <UitkExpandoCard
            isVisible={isVisible}
            handleClick={toggle}
            expandoTitle={
              <UitkSpacing margin={{ inlineend: "twelve" }}>
                <div>
                  <DecorateEditorialHtml text={items[0].text} />
                </div>
              </UitkSpacing>
            }
            expandoDescription={
              <UitkText size={200}>
                <DecorateEditorialHtml text={items[1].text} />
              </UitkText>
            }
            expandoTitleSize={UitkExpandoCardTypeSize.TYPE_400}
          />
        </div>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};

export default CitifaqSection;
